import React from 'react';
//import styles from './Contact.css';
import FacebookLogo from '../../assets/images/FB-f-Logo__blue_29.png';
import LinkedInLogo from '../../assets/images/ln.jpg';
function Contact() {
  return (
<div className="mainContent">
<h1>Contact Claire Hutchinson</h1>

<div id="contact">
      <p>To contact Claire at Ambassador Communications</p>
Call<br />
812-390-7907<br />or email:<br />
<a href="mailto:claire@clairehutchinson.net">claire@clairehutchinson.net</a>
<p>Connect with Claire on <a href="https://www.facebook.com/claire.hutchinson.568" target="_blank" rel="noopener noreferrer"><img src={FacebookLogo} alt="Facebook" /></a> and <a href="http://www.linkedin.com/profile/view?id=30095708" target="_blank" rel="noopener noreferrer"><img src={LinkedInLogo} alt="linked in" /></a></p>
</div>
</div>

  )
  }

export default Contact;